<template>
  <div class="operate">
    <!-- 盈利统计信息 -->
    <div class="statistics">
      <div class="statistics-item">
        <div>
          <p class="statistics-item-title">总收入</p>
          <p class="statistics-item-content">{{ totalRevenue }}</p>
          <div class="adjust-total-cost"></div>
        </div>
        <img class="total-revenue" src="~assets/images/operate/total-revenue.png">
      </div>
      <div class="statistics-item">
        <div>
          <p class="statistics-item-title">总成本</p>
          <p class="statistics-item-content">{{ totalCost }}</p>
          <div class="adjust-total-cost">
            <span class="adjust-total-cost-title">调整总成本</span>
            {{ totalCostIncludeFreeWarehouse }}
          </div>
        </div>
        <img class="total-cost" src="~assets/images/operate/total-cost.png">
      </div>
      <div class="statistics-item">
        <div>
          <p class="statistics-item-title">总毛利</p>
          <p class="statistics-item-content">{{ grossProfi }}</p>
          <div class="adjust-total-cost">
            <span class="adjust-total-cost-title">调整总毛利</span>
            {{ totalGrossProfitIncludeFreeWarehouse }}
          </div>
        </div>
        <img class="gross-profi" src="~assets/images/operate/gross-profi.png">
      </div>
      <div class="statistics-item">
        <div>
          <p class="statistics-item-title">每单毛利</p>
          <p class="statistics-item-content">{{ itemOrderGrossProfi }}</p>
          <div class="adjust-total-cost"></div>
        </div>
        <img class="item-order-gross-profi" src="~assets/images/operate/item-order-gross-profi.png">
      </div>
    </div>
    
    <div class="operate-container">
      <!-- tag切换 -->
      <div class="switch-menu">
        <div>
          <el-radio-group
            class="menu-name"
            v-for="(item, index) in switchList"
            :key="index"
            v-model="selectedTab"
            @change="toUrl(item.url)"
          >
            <el-radio-button :label="item.name"></el-radio-button>
          </el-radio-group>
        </div>
        <div class="export-file" @click="exportExit">
          <img class="upload" src="~assets/images/operate/upload.png">
          <span>导出</span>
        </div>
      </div>

      <!-- 搜索 -->
      <div class="search">
        <div class="search-content">
          <span class="search-title">仓库名称：</span>
          <el-select
            v-model="warehouseId"
            clearable
            placeholder="请选择仓库"
            @change="changeCostAllocationRules"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <span class="search-title">日期：</span>
          <el-date-picker
            class="paddingRight"
            v-model="date"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            placeholder="选择日期">
          </el-date-picker>
          <el-button icon="el-icon-search" class="btn-blue" @click="searchData">搜索</el-button>
          <el-button icon="el-icon-refresh" class="btn-gray" @click="reset">重置</el-button>
        </div>
        <el-button v-if="notVerifiedProjectList.length" type="text" class="btn-text" @click="openNotVerifiedProject">未核实项目</el-button>
      </div>

      <!-- 科目明细列表 -->
      <div class="table daily-details" v-if="isShowArtificialSet && selectedTab === '科目明细'">
        <div class="daily-container">
          <div class="daily-title">物流费用</div>
          <el-table :data="expressFeeList" style="width: 100%" class="express-table" :header-cell-class-name="headerExpressCellClassName">
            <el-table-column
              v-for="(item, index) in expressFeeTitle"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :min-width="item.width"
              :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="daily-container">
          <div class="daily-title">仓储费用</div>
          <el-table :data="warehouseAreaFeeList" style="width: 100%" :header-cell-class-name="headerWarehouseCellClassName">
            <el-table-column
            v-for="(item, index) in warehouseAreaFeeListTitle"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
            :min-width="item.width">
            </el-table-column>
          </el-table>
        </div>
        <div class="daily-container">
          <div class="daily-title operation-title">操作费用</div>
          <div class="daily-adjustment">
            <div class="daily-adjustment-items">
              <p class="daily-adjustment-items-title">操作单量</p>
              <p class="daily-adjustment-items-content">{{ orderNum }}</p>
              <div class="daily-adjustment-items-info">
                <span class="daily-adjustment-items-info-title">调整操作单量</span>
                <span class="daily-adjustment-items-info-content">{{ orderNumConvert }}</span>
                <img class="adjustment-img" src="~assets/images/home/adjustment.png">
              </div>
            </div>
            <div class="daily-adjustment-items">
              <p class="daily-adjustment-items-title">操作件数</p>
              <p class="daily-adjustment-items-content">{{ goodsQuantity }}</p>
              <div class="daily-adjustment-items-info">
                <span class="daily-adjustment-items-info-title">调整操作件数</span>
                <span class="daily-adjustment-items-info-content">{{ goodsQuantityConvert }}</span>
                <img class="adjustment-img" src="~assets/images/home/adjustment.png">
              </div>
            </div>
            <div class="daily-adjustment-items">
              <p class="daily-adjustment-items-title">单均操作收入</p>
              <p class="daily-adjustment-items-content">{{ incomeUnitOrderNum }}</p>
              <div class="daily-adjustment-items-info">
              </div>
            </div>
            <div class="daily-adjustment-items">
              <p class="daily-adjustment-items-title">件均操作成本</p>
              <p class="daily-adjustment-items-content">{{ costUnitGoodsQuantity }}</p>
              <div class="daily-adjustment-items-info">
                <span class="daily-adjustment-items-info-title">调整件均操作成本</span>
                <span class="daily-adjustment-items-info-content">{{ costUnitGoodsQuantityConvert }}</span>
                <img class="adjustment-img" src="~assets/images/home/adjustment.png">
              </div>
            </div>
            <div class="daily-adjustment-items">
              <p class="daily-adjustment-items-title">单均操作成本</p>
              <p class="daily-adjustment-items-content">{{ costUnitOrderNum }}</p>
              <div class="daily-adjustment-items-info">
                <span class="daily-adjustment-items-info-title">调整单均操作成本</span>
                <span class="daily-adjustment-items-info-content">{{ costUnitOrderNumConvert }}</span>
                <img class="adjustment-img" src="~assets/images/home/adjustment.png">
              </div>
            </div>
            <div class="daily-adjustment-items">
              <p class="daily-adjustment-items-title">单均操作毛利</p>
              <p class="daily-adjustment-items-content">{{ grossProfitUnitOrderNum }}</p>
              <div class="daily-adjustment-items-info">
                <span class="daily-adjustment-items-info-title">调整单均操作毛利</span>
                <span class="daily-adjustment-items-info-content">{{ grossProfitUnitOrderNumConvert }}</span>
                <img class="adjustment-img" src="~assets/images/home/adjustment.png">
              </div>
            </div>
          </div>
          <el-table :data="operateFeeList" style="width: 100%" :header-cell-class-name="headerOperateCellClassName">
            <el-table-column
            v-for="(item, index) in operateFeeListTitle"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
            :min-width="item.width">
            </el-table-column>
            <el-table-column 
            min-width="180"
            class-name="cell-right-align-width" prop="tempCost" :label="costAllocationRules == 1? '临时工成本':'toB成本'"></el-table-column>
            <el-table-column 
            min-width="180"
            class-name="cell-right-align-width" prop="regularCost" :label="costAllocationRules == 1? '正式工成本':'toC成本'"></el-table-column>
            <el-table-column 
            min-width="180"
            class-name="cell-right-align-width" prop="grossProfit" label="操作毛利"></el-table-column>
            <el-table-column 
            min-width="180"
            class-name="cell-right-align-width" prop="unitGrossProfit" label="每单毛利"></el-table-column>
          </el-table>
        </div>
        <div class="daily-container">
          <div class="daily-title">索赔费用</div>
          <el-table :data="claimFeeList" style="width: 100%" :header-cell-class-name="headerWarehouseCellClassName">
            <el-table-column
            v-for="(item, index) in claimFeeListTitle"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
            :min-width="item.width">
            </el-table-column>
          </el-table>
        </div>
        <div class="daily-container">
          <div class="daily-title">其他费用</div>
          <el-table :data="otherFeeList" style="width: 100%" :header-cell-class-name="headerOperateCellClassName">
            <el-table-column
            v-for="(item, index) in otherFeeListTitle"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.width"
            :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="daily-container">
          <div class="daily-title">其他成本</div>
          <el-table :data="otherCostList" style="width: 100%" :header-cell-class-name="headerOperateCellClassName">
            <el-table-column
            v-for="(item, index) in otherCostListTitle"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.width"
            :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import profitMixins from '@/common/mixins/profit'
export default {
  mixins: [profitMixins],

  data() {
    return {
      selectedTab: '科目明细',
    }
  },

  activated() {
    this.selectedTab = '科目明细'
  },

  created() {},

  methods: {
  }
}
</script>


<style lang="scss" scoped>
.operate {
  flex: 1;
  display: flex;
  flex-direction: column;
  .statistics {
    width: 100%;
    height: 120px;
    @include flex-between;
    margin-bottom: 20px;
    &-item {
      width: 25%;
      height: 100%;
      border-radius: 4px;
      background: white;
      margin-right: 20px;
      @include flex-between;
      box-sizing: border-box;
      padding: 0px 30px 0px 19px;
      border: 1px solid $baseFourSnow;
      .total-revenue {
        width: 93px;
        height: 27px;
      }
      .total-cost {
        width: 92px;
        height: 30px;
      }
      .gross-profi,
      .item-order-gross-profi {
        width: 48px;
        height: 48px;
      }
      &-title {
        font-size: 12px;
        font-family: 'PingFang SC-Regular, PingFang SC';
        font-weight: 400;
        color: $baseTwoGrey;
        margin-bottom: 10px;
      }
      &-content {
        height: 28px;
        line-height: 28px;
        font-size: 20px;
        font-family: 'PingFang SC-Heavy, PingFang SC';
        font-weight: 800;
        color: $baseGrey;
        margin-bottom: 10px;
      }
      .adjust-total-cost {
        height: 12px;
        font-size: 12px;
        font-family: 'PingFang SC-Regular, PingFang SC';
        font-weight: 400;
        color: $baseGrey;
        &-title {
          color: $baseThreeGrey;
          margin-right: 10px;
        }
      }
    }
    &-item:last-child {
      margin-right: 0px;
    }
  }
  .operate-container {
    flex: 1;
    border-radius: 4px 4px 0px 0px;
    background: white;
  }
  .search {
    padding: 20px 24px 0px 24px;
    background: #fff;
    border-radius: 4px;
    @include flex-between;
    .search-content {
      display: flex;
      .search-title {
        font-size: 14px;
        font-weight: 400;
        color: $baseGrey;
        line-height: 32px;
      }
      .el-select {
        margin-right: 30px;
      }
      .el-date-editor {
        margin-right: 20px;
      }
    }
    .btn-blue {
      margin: 0;
    }
    .el-button {
      padding-top: 0px;
      padding-bottom: 0px;
    }
    .paddingRight {
      margin-right: 16px;
    }
  }
  .daily-details {
    margin-bottom: 20px;
    padding: 16px 24px;
    .daily-container {
      margin-bottom: 20px;
      .daily-title {
        font-size: 14px;
        font-weight: 400;
        color: $baseGrey;
        padding-left: 4px;
        margin-bottom: 10px;
        border-left: 3px solid $baseBlue;
      }
      .operation-title {
        margin-bottom: 0px;
      }
      .daily-adjustment {
        height: 122px;
        @include flex-start;
        box-sizing: border-box;
        &-items {
          box-sizing: border-box;
          padding: 0px 20px;
          position: relative;
          width: 25%;
          &-title {
            font-size: 12px;
            font-family: 'PingFang SC-Regular, PingFang SC';
            font-weight: 400;
            color: $baseTwoGrey;
          }
          &-content {
            line-height: 28px;
            font-size: 20px;
            font-family: 'PingFang SC-Heavy, PingFang SC';
            font-weight: 800;
            color: $baseGrey;
            margin: 10px 0px;
          }
          &-info {
            @include flex-start;
            align-items: flex-start;
            height: 12px;
            &-title {
              font-size: 12px;
              font-family: 'PingFang SC-Regular, PingFang SC';
              font-weight: 400;
              color: $baseThreeGrey;
              margin-right: 10px;
            }
            &-content {
              font-size: 12px;
              font-family: 'PingFang SC-Regular, PingFang SC';
              font-weight: 400;
              color: $baseGrey;
              margin-right: 4px;
            }
            .adjustment-img {
              width: 22px;
              height: 12px;
            }
          }
          &::after {
            position: absolute;
            right: 0px;
            top: 50%;
            transform: translateY(-50%);
            content: '';
            width: 1px;
            height: 64px;
            background: $baseThreeSnow;
          }
        }
        &-items:first-child {
          padding-left: 32px;
        }
        &-items:last-child {
          &::after {
            display: none;
          }
        }
      }
    }
  }
  .table {
    background: #fff;
    border-radius: 4px;
    .hign-red {
      // color: #FF0909;
    }
    .right-align-width {
      width: 110px;
      text-align: right;
    }
    .totle-price {
      height: 48px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      padding: 0px 16px;
      border-bottom: 1px solid #eee;
      p {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
      }
    }
    .table-container {
      padding: 16px;
    }
    .el-table {
      .cell {
        position: relative;
        .remarks {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-right: 14px;
        }
        .icon {
          position: absolute;
          right: 1px;
          top: 9px;
          cursor: pointer;
        }
      }
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
<style lang="scss">
.operate {
  .switch-menu {
    width: 100%;
    height: 48px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    padding: 0px 20px;
    box-sizing: border-box;
    border-bottom: 1px solid $baseThreeSnow;
    border-radius: 4px 4px 0px 0px;
    .menu-name {
      height: 48px;
      line-height: 46px;
      margin-right: 32px;
      .el-radio-button__inner {
        font-size: 16px;
        font-weight: bold;
        border: none;
        color: $baseGrey;
        background: transparent;
        padding: 0;
        font-family: 'PingFang SC-Regular, PingFang SC';
      }
      .is-active {
        border-bottom: 2px solid $baseBlue;
        .el-radio-button__inner {
          color: $baseBlue;
        }
      }
    }
    .export-file {
      @include flex-start;
      cursor: pointer;
      .upload {
        width: 16px;
        height: 16px;
        margin-right: 2px;
        font-size: 14px;
        font-weight: 400;
        color: $baseGrey;
      }
    }
  }
  .el-select.gray .el-input__suffix {
    top: 0px;
  }
  .table {
    .el-table {
      .el-input {
        .el-input__inner {
          height: 24px;

          padding-left: 5px;
          padding-right: 0px;
        }
      }
      .cell-right-align-width {
        .cell {
          width: 126px;
          text-align: right;
        }
      }
    }
    
    .express-table,
    .customer-table {
      .el-table__body-wrapper {
        .el-table__row:last-child {
          td {
            .cell {
              font-weight: 500;
              color: $baseGrey;
            }
          }
        }
      }
    }
  }
  .table .el-table .el-table__header-wrapper .el-table__header tr th.right-align {
    .cell {
      width: 142px;
      text-align: right;
    }
  }
  .not-verified-drawer {
    .el-drawer {
      width: 480px!important;
    }
    .el-drawer__header {
      margin-bottom: 0px;
    }
    .el-drawer__body {
      height: calc(100% - 56px);
      @include flex-column-between;
      overflow-y: auto;
      @include scrollbarNotrack(4px);
      .el-collapse {
        border: 0px;
        padding: 0px;
        &-item {
          border-bottom: 0px;
          &__header {
            font-size: 14px;
            font-family: 'PingFang SC-Regular, PingFang SC';
            font-weight: 400;
            color: $baseGrey;
            border: 0px;
            .arrow-right {
              width: 16px;
              height: 16px;
              margin-right: 4px;
              transition: all 0.4s;
            }
            .amount-info {
              color: $baseThreeGrey;
              .amount-text {
                margin-right: 30px;
              }
            }
            .el-collapse-item__arrow {
              display: none;
            }
          }
          &__header.is-active {
            .arrow-right {
              transform: rotate(90deg);
              transition: all 0.4s;
            }
          }
          &__wrap {
            border: 0px;
          }
          &__content {
            padding-bottom: 16px;
            .project-row {
              @include flex-start;
              height: 32px;
              padding: 0px 10px;
              background: $baseSixSnow;
              margin-bottom: 16px;
              &-name {
                width: 116px;
                font-size: 14px;
                font-family: 'PingFang SC-Regular, PingFang SC';
                font-weight: 400;
                color: $baseGrey;
                @include two-wrap-ellipsis(1);
              }
              .revenue-expenditure {
                flex: 1;
                @include flex-around;
                font-size: 14px;
                font-family: 'PingFang SC-Regular, PingFang SC';
                font-weight: 400;
                color: $baseGrey;
                &-img {
                  width: 14px;
                  height: 14px;
                  margin-bottom: 2px;
                }
              }
            }
            .project-row:last-child {
              margin-bottom: 0px;
            }
          }
        }
      }
    }
  }
}
</style>
